module.exports = __webpack_public_path__ + "img/watage_res_18.2e3b58f4.gif";